import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  withCredentials: false,
  timeout: 12000
});

// Attach Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('meed.token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const message = err.response?.data?.message || err.message || 'Request failed';
    const errors = err.response?.data?.errors || null;
    return Promise.reject({ message, errors, status: err.response?.status });
  }
);

export const sessionId = (() => {
  if (typeof window === 'undefined') return 'guest';
  let id = window.localStorage.getItem('meed.session');
  if (!id) {
    id = (crypto?.randomUUID?.() || `s${Date.now()}${Math.random().toString(36).slice(2, 8)}`).replace(/[^A-Za-z0-9\-_.]/g, '');
    window.localStorage.setItem('meed.session', id);
  }
  return id;
})();

export const catalog = {
  home: () => api.get('/home').then((r) => r.data.data),
  categories: () => api.get('/catalog/categories').then((r) => r.data.data),
  products: (params) => api.get('/catalog/products', { params }).then((r) => r.data.data),
  product: (id) => api.get(`/catalog/products/${id}`).then((r) => r.data.data),
  zones: () => api.get('/catalog/zones').then((r) => r.data.data)
};

export const cart = {
  show: () => api.get('/cart', { params: { session_id: sessionId } }).then((r) => r.data.data),
  add: (productId, qty = 1) => api.post('/cart/items', { session_id: sessionId, product_id: productId, qty }).then((r) => r.data.data),
  setQty: (productId, qty) => api.patch('/cart/items', { session_id: sessionId, product_id: productId, qty }).then((r) => r.data.data)
};

export const orders = {
  checkout: (payload) => api.post('/checkout/order', { session_id: sessionId, ...payload }).then((r) => r.data.data),
  show: (id) => api.get(`/orders/${id}`).then((r) => r.data.data),
  list: (params) => api.get('/orders', { params }).then((r) => r.data.data)
};

export const auth = {
  login: (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data.data),
  register: (payload) => api.post('/auth/register', payload).then((r) => r.data.data),
  logout: () => api.post('/auth/logout').then((r) => r.data.data),
  me: () => api.get('/auth/me').then((r) => r.data.data)
};
